import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "keyword-detail" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_5 = {
  key: 1,
  class: "notice notice-error"
}
const _hoisted_6 = { class: "metric-grid" }
const _hoisted_7 = { class: "metric" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "월간 검색량", -1)
const _hoisted_9 = { class: "metric-value" }
const _hoisted_10 = { class: "metric-sub" }
const _hoisted_11 = { class: "metric" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "월간 발행량", -1)
const _hoisted_13 = { class: "metric-value" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "metric-sub" }, "블로그 문서 수", -1)
const _hoisted_15 = { class: "metric" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "포화 지수", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "metric-sub" }, "낮을수록 유리", -1)
const _hoisted_18 = { class: "metric" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "경쟁정도", -1)
const _hoisted_20 = { class: "metric-value" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "metric-sub" }, "네이버 광고 기준", -1)
const _hoisted_22 = { class: "chart-card" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "최근 1년 검색 추이", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "chart-note" }, [
  /*#__PURE__*/_createTextVNode(" 데이터랩 기준 "),
  /*#__PURE__*/_createElementVNode("b", null, "상대비율"),
  /*#__PURE__*/_createTextVNode("입니다(구간 최고점 = 100). 절대 검색량이 아닙니다. ")
], -1)
const _hoisted_25 = { class: "chart-area" }
const _hoisted_26 = {
  key: 1,
  class: "chart-skeleton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, "← 목록"),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.decodedKeyword), 1)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "불러오는 중…"))
      : (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
        : (_ctx.detail)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("section", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.detail.totalVolume.toLocaleString()), 1),
                  _createElementVNode("div", _hoisted_10, " PC " + _toDisplayString(_ctx.detail.pcVolume.toLocaleString()) + " · 모바일 " + _toDisplayString(_ctx.detail.mobileVolume.toLocaleString()), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.detail.docCount === null ? "-" : _ctx.detail.docCount.toLocaleString()), 1),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", {
                    class: _normalizeClass(["metric-value", _ctx.saturationClass])
                  }, _toDisplayString(_ctx.detail.saturation === null ? "-" : _ctx.detail.saturation.toFixed(2)), 3),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.detail.competition || "-"), 1),
                  _hoisted_21
                ])
              ]),
              _createElementVNode("section", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.chartData)
                    ? (_openBlock(), _createBlock(_component_Line, {
                        key: 0,
                        data: _ctx.chartData,
                        options: _ctx.chartOptions,
                        class: "chart"
                      }, null, 8, ["data", "options"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, "추이 데이터가 없습니다."))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}